import { render, staticRenderFns } from "./LocalCombine.vue?vue&type=template&id=29a74778&scoped=true&"
import script from "./LocalCombine.vue?vue&type=script&lang=ts&"
export * from "./LocalCombine.vue?vue&type=script&lang=ts&"
import style0 from "./LocalCombine.vue?vue&type=style&index=0&id=29a74778&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a74778",
  null
  
)

export default component.exports